import React from "react";
import Reveal from "../common/Reveal";

const VideoShowcase = () => {
  return (
    <section className="relative isolate overflow-hidden">
      <video
        className="absolute inset-0 h-full w-full object-cover"
        src="/solution.mp4"
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/40 to-primary-950/60" />

      <Reveal className="relative mx-auto max-w-3xl px-4 py-40 text-center sm:px-6 lg:px-8">
        <span className="text-sm font-semibold uppercase tracking-wide text-accent-200">
          MTST TECHNOLOGY
        </span>
        <h2 className="mt-3 break-keep text-3xl font-bold leading-snug text-white sm:text-4xl">
          기초부터 지능화까지,
          <br />
          All-in-One 스마트 팩토리 솔루션
        </h2>
        <p className="mt-4 break-keep text-base text-gray-200">
          MES부터 AI 분석까지, 하나의 플랫폼으로 연결합니다
        </p>
      </Reveal>
    </section>
  );
};

export default VideoShowcase;
